import { PlaceType } from '@web/gql/graphql'

export const isBookmarkShowable = <
  Place extends { isAvailable?: boolean; type: PlaceType; isBusinessPlace?: boolean } | null,
>(
  place?: Place,
): place is NonNullable<Place> => !!place?.isAvailable && place.type === PlaceType.Korea && !place.isBusinessPlace
